"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEvent = void 0;
const pffkit_js_core_1 = require("@pro-football-focus/pffkit-js-core");
function createEvent(response, awayTeam, homeTeam) {
    const event = new pffkit_js_core_1.Event(response.eventId, response.sportsbookEventId, response.sportradarId, homeTeam, awayTeam, response.weekAbv, new Date(response.startTimestamp), response.eventStatus, response.homeScore, response.awayScore);
    return event;
}
exports.createEvent = createEvent;
//# sourceMappingURL=events_request.js.map